import React, { useState, useEffect } from 'react';

export const Admin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loggedIn, setLoggedIn] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [youtubeData, setYoutubeData] = useState('');
  const [editedData, setEditedData] = useState('');
  const [file, setFile] = useState(null);

  useEffect(() => {
    fetchYoutubeData();
  }, []);

  const fetchYoutubeData = () => {
    fetch('https://collaboratenust.pythonanywhere.com/youtube-links')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        return response.json();
      })
      .then(data => {
        setYoutubeData(data?.data);
        setEditedData(data?.data); // Set initial value for editing
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  const handleLogin = () => {
    if (email === 'collaborate@nust.edu.pk' && password === '$Collaboration6232') {
      setLoggedIn(true);
    } else {
      alert('Incorrect email or password');
    }
  };

  const handleSave = () => {
    // Get the edited data from the textarea
    const newData = editedData;

    // Send a POST request to update the data on the server
    fetch('https://collaboratenust.pythonanywhere.com/youtube-links', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ data: newData })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          console.log('Data saved successfully');
          setEditMode(false); // Exit edit mode
          fetchYoutubeData(); // Fetch the updated data (optional
        } else {
          console.error('Failed to save data:', result.error);
        }
      })
      .catch(error => {
        console.error('Error saving data:', error);
      });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };


  const handleImageUpload = () => {
    if (!file) {
      alert('Please select an image');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);

    fetch('https://collaboratenust.pythonanywhere.com/slider', {
      method: 'POST',
      body: formData // Pass the FormData object as the body of the request
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          alert('Image uploaded successfully');
        } else {
          console.error('Failed to upload image:', result.error);
        }
      })
      .catch(error => {
        console.error('Error uploading image:', error);
      });
  };


  return (
    <div className="container-fluid d-flex align-items-center justify-content-center" style={{ minHeight: '75vh' }}>
      <div className="col-md-6">
        <div className="card">
          <div className="card-body">
            {!loggedIn ? (
              <>
                <h3 className="card-title text-center mb-4">Admin Login</h3>
                <div className="mb-3">
                  <input type="email" className="form-control" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
                </div>
                <div className="mb-3">
                  <input type="password" className="form-control" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
                </div>
                <div className="d-grid gap-2">
                  <button className="btn btn-primary" onClick={handleLogin}>Login</button>
                </div>
              </>
            ) : (
              <>
                {!editMode ? (
                  <>
                    <h3 className="card-title text-center mb-4">Admin Dashboard</h3>
                    <p className="text-center">Youtube Videos link</p>
                    <div className="mb-3">
                      <textarea className="form-control" value={youtubeData} readOnly style={{ width: '100%', minHeight: '200px' }} />
                    </div>
                    <div className="d-grid gap-2">
                      <button className="btn btn-primary" onClick={() => setEditMode(true)}>Edit</button>
                    </div>
                  </>
                ) : (
                  <>
                    <h3 className="card-title text-center mb-4">Edit Youtube Videos</h3>
                    <p className="text-center">Add text above edit youtube videos</p>
                    <div className="mb-3">
                      <textarea className="form-control" value={editedData} onChange={e => setEditedData(e.target.value)} style={{ width: '100%', minHeight: '200px' }} />
                    </div>
                    <div className="d-grid gap-2">
                      <button className="btn btn-primary" onClick={handleSave}>Save</button>
                    </div>
                  </>
                )}
                <div className="mb-3">
                  <input type="file" className="form-control" onChange={handleFileChange} />
                </div>
                <div className="d-grid gap-2">
                  <button className="btn btn-primary" onClick={handleImageUpload}>Upload Image</button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
